<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    南联站<br>
站点介绍<br>
南联站位于深圳市龙岗区龙岗大道与碧新路交叉口以南，呈西南至东北方向布置，西南接龙城广场站，东北接双龙站。车站位于南联龙岗大道上，往双龙方向有碧新路与龙岗大道形成交叉，往益田方向则为植物园路、南联路以及龙岗大道的三路交汇口。南联站以白色为主色调，柱体采用白色搪瓷钢板，在标准化、简约化的装修中赋予了车站浓厚的文化气息。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:21	23:02	3号线	2分15-20秒	4分30秒<br>
双龙	06:21	00:10	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:22	23:02	3号线	3分15秒	5分钟<br>
双龙	06:24	00:09	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:22	00:02	3号线	3分15秒	5分钟<br>
双龙	06:24	01:09	3号线	3分15秒	5分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
龙岗大道南侧（西）<br><br>
A2出入口:<br>
远洋新干线、南联小学、南联植物园、南约社区、龙富花园、南联第六工业区<br><br>
B1出入口:<br>
碧新路、鹏达花园、彩虹城、世宏大厦<br><br>
B2出入口:<br>
龙岗街道办、龙岗长途汽车站、龙岗国税局、龙岗大道南侧<br><br>
B3出入口:<br>
建设路<br><br>
B4出入口:<br>
摩尔城<br><br>
C1出入口:<br>
龙岗大道北侧、九洲家园、罗瑞合社区、龙岗客家民俗博物馆、七巧国儿童中心<br><br>
C2出入口:<br>
佰好大厦、南兴大厦、旭源大厦<br><br>
公交换乘信息<br><br>
A2出入口:<br>
公交站名： 南联地铁站<br>
811,818,351,M266,M275,M359,M361,E6,M394,深惠3A,M546,E33,E34,M136,M139,M165,M195,M220,M239,M307,M266，M396<br><br>
B1出入口:<br>
公交站名： 摩尔城<br>
M317<br><br>
B2出入口:<br>
公交站名： 海航城<br>
M396,818,351,811,E34,M136,M139,M195,M220,M239,M266,M275,M280,M305,M307,M359,M361,M394,M546,深惠3A<br><br>
B3出入口:<br>
公交站名： 摩尔城<br>
M317路<br><br>
C2出入口:<br>
公交站名： 南联地铁站<br>
811,818,351,M266,M275,M359,M361,E6,M556,深惠3A,M546,E33,E34,M136,M139,M165,M195,M220,M239,M307,M266,M396<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


